import React from 'react'

const TitleDescription = (props: any) => {
  return (
    <div className={`px-0 sm:px-[16px] ${props.contentStyles}`}>
        <div className="flex gap-x-[12px] items-center mb-[24px] sm:w-full sm:justify-between">
            <h1 className={`${props.headerStyles ? props.headerStyles : "text-[36px] leading-[54px] sm:text-[16px] sm:leading-[24px] font-bold"}`}>{props.title}</h1>
            {(props.percentage || props.percentageUntil) &&
                <div className="relative py-[10px] px-[20px] flex items-center justify-center">
                <img
                    className='absolute left-0 -z-10 w-full sm:w-[80px]'
                    src="/images/pharmacy/pharmaHouse/salesRectangle.svg"
                    alt="sale"
                />
                {props.percentage &&
                    <p
                        className="leading-[27px] w-full text-[18px] sm:text-[14px] sm:leading-[21px] font-bold text-[#FFFFFF]"
                    >
                        -{props.percentage}%
                    </p>
                }

                {props.percentageUntil && 
                        <p
                            className="leading-[21px] min-w-[80px] text-[14px] sm:text-[10px] sm:px-[0px] font-bold text-[#FFFFFF]"
                        >
                            -{props.percentageUntil}%-მდე
                        </p>
                }
            </div>
            }
        </div>
        {props.description1 && 
            <h3 className="text-[24px] leading-[36px] sm:hidden text-primary font-semibold">
                {props.description1}
            </h3>
        }
        {props.description && 
            <p className={`mb-5 font-medium text-lightgray text-[16px] sm:text-[12px] leading-[21px] sm:leading-[18px] mt-[14px] ${props.descriptionStyles}`}>
                {!props.withoutStar && <span className="text-raspberry-100 leading-[21px] text-[14px] font-semibold">* </span>}{props.description}
            </p>
        }
    </div>
  )
}

export default TitleDescription